import { UserAcceptCampaignActions } from './user-accept-campaign.actions';

export interface IUserAcceptCampaign {
    accept: boolean;
	userCblc: string;
	expiration: number;
	guidContrato: string;
	description: string;
	id: string;
	title: string;
    campaignName: string;
    versionId: number;
    agreementFile: string;
    agreementId: number;
}

export class UserAcceptCampaignState {
    public pending: boolean;
    public userAcceptCampaignData: IUserAcceptCampaign[] | []
}

export const initialState: UserAcceptCampaignState = {
    pending: false,
    userAcceptCampaignData: []
};


export function UserAcceptCampaignReducer(
    state: UserAcceptCampaignState = initialState,
    action?: UserAcceptCampaignActions
) {
    switch (action.type) {
        // 
        case UserAcceptCampaignActions.getUserAcceptCampaign:
            return { ...state, ...{ pending: true } };


        // 
        case UserAcceptCampaignActions.getUserAcceptCampaignSuccess:
            return {
                ...state,
                ...{
                    pending: false,
                    userAcceptCampaignData: action.payload.data
                },
            };

        // 
        case UserAcceptCampaignActions.getUserAcceptCampaignError:
            return {
                ...state,
                ...{
                    pending: false,
                    userAcceptCampaignData: action.payload.data
                },
            };


        case UserAcceptCampaignActions.putUserAcceptCampaign:
            return { ...state, ...{ pending: true } };


        // 
        case UserAcceptCampaignActions.putUserAcceptCampaignSuccess:
            return {
                ...state,
                ...{
                    pending: false,
                    userAcceptCampaignData: action.payload.data
                },
            };

        // 
        case UserAcceptCampaignActions.putUserAcceptCampaignError:
            return {
                ...state,
                ...{
                    pending: false,
                    userAcceptCampaignData: action.payload.data
                },
            };
        

        default:
            return state;
    }
}

